/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/jquery/aacom/webworker/handlebarWorker.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/webworker/handlebar-worker.js
**/

/* global importScripts:true */

importScripts('https://www.aa.com/assets/js/vendor/handlebars.min.js');
importScripts('https://www.aa.com/assets/js/modules/handlebar.min.js');

handlebarsModule.init();

self.onmessage = function(e) {
	if(e.data){
		switch(e.data.action){
			case "addTemplate":
				handlebarsModule.addTemplate(e.data.key,e.data.data);
				break;
			case "parseTemplate":
				handlebarsModule.parseTemplate(e.data.key,e.data.data,e.data.templateContainer);
				break;
		}
	}
};
